import script from "./ModalMonthlySignature.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMonthlySignature.vue?vue&type=script&setup=true&lang=js"

import "./ModalMonthlySignature.vue?vue&type=style&index=0&id=01956661&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01956661"]])

export default __exports__